import React from "react";
import { motion } from "framer-motion";
import { SectionHeader } from "./About";

export default function Education({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <section id="education" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <SectionHeader number="03" overline="Education" title="Academic foundation." />
        <div className="mt-14 space-y-4">
          {items.map((e, i) => (
            <motion.div
              key={e.id || i}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              className="card-tech p-5"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="font-display font-semibold text-base">{e.degree}</p>
                  <p className="text-fog-300 text-sm mt-1">{e.institution}</p>
                  {e.location && <p className="text-fog-400 text-xs mt-1">{e.location}</p>}
                </div>
                <p className="overline text-volt whitespace-nowrap">
                  {e.start_year}{e.end_year ? `–${e.end_year}` : ""}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
    </div>
   </section>
  );
}
